import { MenuState } from '../models/enums/Menu';
import { defineStore } from 'pinia';

export const useMenuStore = defineStore('menu', {
  // arrow function recommended for full type inference
  state: () => ({
    menuState: [MenuState.Main],
    machineMenuState: '',
    drawer: false,
    loadingMachines: false,
    loadingMissions: false
  }),
  getters: {
    currentMenuState(): string {
      return this.menuState[this.menuState.length - 1];
    }
  },
  actions: {
    setLoadingMachines(state: boolean) {
      this.loadingMachines = state;
    },
    setLoadingMissions(state: boolean) {
      this.loadingMissions = state;
    },
    setDrawer(value: boolean): void {
      this.drawer = value;
      if (!this.drawer) this.menuState = [MenuState.Main];
    },
    pushMenuState(state: MenuState) {
      if (!this.menuState.includes(state)) this.menuState.push(state);
    },
    popMenuState() {
      if (this.menuState.length > 1) this.menuState.pop();
    },
    setMachineMenuState(state: string) {
      this.machineMenuState = state;
    },
    resetMachineMenuState() {
      this.menuState = [MenuState.Main];
    },
    setupMachineMenuState() {
      this.menuState = [MenuState.Main, MenuState.Machines, MenuState.MachineSelected];
      this.drawer = true;
    }
  }
});
